import type { Braindump } from './types';

/**
 * Whether a dump still belongs in the Inbox queue.
 *
 * "Applied" means every item was decided -- accepted or rejected, nothing
 * left proposed. At that point the dump has done its job; keeping it in the
 * list would mean deleting it by hand just to make the queue match reality.
 */
export function isDumpVisible(dump: Pick<Braindump, 'status'>): boolean {
  return dump.status !== 'applied';
}
